import {
    LineChart,
    Line,
    AreaChart,
    Area,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    Legend,
    ComposedChart
} from 'recharts';
import { formatCurrency, formatNumber, formatDateIntl, formatWithStyle, formatInterestFra } from "../../util/currency_lookup";

export const PortfolioChart = ({ overtimePosition, selectedCurrency }) => {
    const chartConfig = {
        height: 450,
        margins: { top: 20, right: 60, left: 20, bottom: 5 },
        legend: {
            height: 36,
            padding: '20px'
        }
    };

    // Calculate min and max values for each axis
    const getAxisDomain = (data, keys) => {
        const allValues = data.flatMap(item => 
            keys.map(key => item[key])
        ).filter(val => val !== undefined && val !== null);
        
        const min = Math.min(...allValues);
        const max = Math.max(...allValues);
        
        // Add some padding (10%) to the domain
        const padding = (max - min) * 0.1;
        return [min - padding, max + padding];
    };

    // Get domains for both axes
    const leftAxisKeys = ['monthly_invested', 'monthly_withdrawn', 'interest_earned'];
    const rightAxisKeys = ['total_invested_to_date', 'total_withdrawn_to_date'];
    
    const leftDomain = getAxisDomain(overtimePosition, leftAxisKeys);
    const rightDomain = getAxisDomain(overtimePosition, rightAxisKeys);

    return (
        <ResponsiveContainer width="100%" height={chartConfig.height}>
            <ComposedChart 
                data={overtimePosition}
                margin={chartConfig.margins}
            >
                <CartesianGrid strokeDasharray="3 3" />
                
                <XAxis 
                    dataKey="month_start" 
                    tickFormatter={(date) => formatDateIntl(date, 'short')}
                />
                
                <YAxis
                    yAxisId="left"
                    orientation="left"
                    domain={leftDomain}  // Set the domain for left axis
                    tickFormatter={(value) => formatWithStyle(
                        value, 
                        'compact', 
                        selectedCurrency
                    )}
                />
                
                <YAxis
                    yAxisId="right"
                    orientation="right"
                    domain={rightDomain}  // Set the domain for right axis
                    tickFormatter={(value) => formatWithStyle(
                        value, 
                        'compact', 
                        selectedCurrency
                     )}
                />
                
                <Tooltip 
                    formatter={(value) => formatWithStyle(value, 'compact', selectedCurrency)}
                    labelFormatter={(date) => formatDateIntl(date)}
                />

                {/* Chart series with explicit y-axis scales */}
                <Line
                    yAxisId="left"
                    type="monotone" 
                    dataKey="monthly_invested" 
                    stroke="#22c55e"
                    name="Monthly Invested"
                    strokeDasharray="5 5"
                    dot={false}  // Optionally remove dots for cleaner look
                    activeDot={{ r: 8 }}
                />
                <Line
                    yAxisId="left"
                    type="monotone" 
                    dataKey="monthly_withdrawn" 
                    stroke="#ef4444"
                    name="Monthly Withdrawn"
                    strokeDasharray="5 5"
                    dot={false}
                    activeDot={{ r: 8 }}
                />
                <Area
                    yAxisId="left" 
                    type="monotone" 
                    dataKey="interest_earned" 
                    name="Interest Earned"
                    stroke="#6366f1"
                    fill="#6366f1" 
                    fillOpacity={0.1}
                    dot={false}
                />
                <Line
                    yAxisId="right" 
                    type="monotone" 
                    dataKey="total_invested_to_date" 
                    name="Total Invested to date"
                    stroke="#0ea5e9"
                    fill="#0ea5e9" 
                    fillOpacity={0.1}
                />
                <Line
                    yAxisId="right" 
                    type="monotone" 
                    dataKey="total_withdrawn_to_date" 
                    name="Total withdrawn to date"
                    stroke="#f97316"
                    fill="#f97316" 
                    fillOpacity={0.1}
                    dot={false}
                />

                <Legend 
                    verticalAlign="top"
                    height={chartConfig.legend.height}
                    wrapperStyle={{ paddingBottom: chartConfig.legend.padding }}
                />
            </ComposedChart>
        </ResponsiveContainer>
    );
};
